// App
export const APP_LOADING = 'APP_LOADING'
export const APP_LOADING_TEXT = 'APP_LOADING_TEXT'
export const APP_INIT_EDITOR = 'APP_INIT_EDITOR'

// Navigation
export const NAVIGATION_ACTIVE = 'NAVIGATION_ACTIVE'

// Shape
export const SHAPE_LIST = 'SHAPE_LIST'
export const SHAPE_SCALE = 'SHAPE_SCALE'
export const SHAPE_GROUP = 'SHAPE_GROUP'

// Current
export const CURRENT_INIT = 'CURRENT_INIT'
export const CURRENT_INIT_ALL = 'CURRENT_INIT_ALL'
export const CURRENT_UPDATE = 'CURRENT_UPDATE'
export const CURRENT_FILE = 'CURRENT_FILE'
export const CURRENT_ROTATE = 'CURRENT_ROTATE'
export const CURRENT_SCALE = 'CURRENT_SCALE'
export const CURRENT_SHAPE = 'CURRENT_SHAPE'
export const CURRENT_X = 'CURRENT_X'
export const CURRENT_Y = 'CURRENT_Y'
export const CURRENT_NUMBER = 'CURRENT_NUMBER'
export const CURRENT_IMAGE_WIDTH = 'CURRENT_IMAGE_WIDTH'
export const CURRENT_IMAGE_HEIGHT = 'CURRENT_IMAGE_HEIGHT'

// BadgeList
export const BADGE_LIST_INIT = 'BADGE_LIST_INIT'
export const BADGE_LIST_ADD = 'BADGE_LIST_ADD'
export const BADGE_LIST_UPDATE = 'BADGE_LIST_UPDATE'
export const BADGE_LIST_DELETE = 'BADGE_LIST_DELETE'
export const BADGE_LIST_SELECTED = 'BADGE_LIST_SELECTED'
